import { createFileRoute } from "@tanstack/react-router";

import { OnboardingHome } from "../../../features/onboarding/OnboardingHome";

export const Route = createFileRoute("/_app/onboarding/")({
  component: OnboardingHome,
});
